import {getAccessToken} from "../extensions/userInfoExtension";
import axios from "axios";

export const createUser = async () => {
  let configuration = {
    method: 'post',
    maxBodyLength: Infinity,
    url: '/prod/user',
    headers: {
      'accept': '*/*',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${getAccessToken()}`
    }
  }

  return await axios.request(configuration)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
}

export const getUser = async () => {
  let configuration = {
    method: 'get',
    maxBodyLength: Infinity,
    url: '/prod/user',
    headers: {
      'accept': '*/*',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${getAccessToken()}`
    }
  }

  return await axios.request(configuration)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });

}

export const putUser = async (firstName, lastName, vatNumber, invoiceEmail) => {
  let configuration = {
    method: 'put',
    maxBodyLength: Infinity,
    url: '/prod/user',
    headers: {
      'accept': '*/*',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${getAccessToken()}`
    },
    data: {
      "firstName": `${firstName.trim()}`,
      "lastName": `${lastName.trim()}`,
      "vat": vatNumber?.trim() === undefined ? null : vatNumber?.trim(),
      "invoiceEmail": invoiceEmail?.trim() === undefined ? null : invoiceEmail?.trim(),
    }
  }

  return await axios.request(configuration)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });

}